import {Fragment, useState} from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Modal from './Modal'

import './infoTile.scss'

const InfoTile = props => {
  const [showModal, setShowModal] = useState(false)

  const InfoIcon = props.icon
  const Action = props.action

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const revokeAccess = () => {
    props.revoke()
    toggleModal()
  }

  return (
    <Fragment>
      <Stack className={classnames('info-tile', props.className)} component='div' sx={{bgcolor: 'Background', flexDirection: 'row', justifyContent: 'space-between'}}>
        <Stack className='summary' component='div' sx={{flexDirection: 'row'}}>
          <Stack className='icon' component='div' sx={{justifyContent: 'center', alignItems: 'center', marginRight: '7px'}}>
            <InfoIcon color={props.iconColor} fontSize='large' />
          </Stack>
          <Stack className='details' component='div' sx={{justifyContent: 'center'}}>
            <Typography className='heading' variant='body1'>{props.label}</Typography>
            {
              props.details.map(
                (data, index) => <Typography className='content' key={index} variant='body2'>{data}</Typography>
              )
            }
            {props.children}
          </Stack>
        </Stack>
        {
          props.action && <Action {...props} onClick={toggleModal} />
        }
      </Stack>
      <Modal maxWidth='lg' open={showModal} handleClose={toggleModal} title={`Remove ${props.label}`} buttonText='Close'>
        <Typography color='error' gutterBottom>Are you sure you want to proceed?</Typography>
        <ButtonGroup direction='row'>
          <Button color='error' onClick={toggleModal}>Cancel</Button>
          <Button color='primary' loading={props.loading} onClick={revokeAccess}>Confirm</Button>
        </ButtonGroup>
      </Modal>
    </Fragment>
  )
}

InfoTile.propTypes = {
  label: PropTypes.string,
  details: PropTypes.arrayOf(PropTypes.string),
  // any MUI palette name; left out, the icon takes the tile's own text colour
  iconColor: PropTypes.string
}

export default InfoTile
